import { ProposalType } from '@shared/graphql'

/**
 * Type guard to check if a proposal type is valid.
 */
export const isProposalType = (
  proposalType: unknown,
): proposalType is ProposalType =>
  Object.values(ProposalType).includes(proposalType as ProposalType)

/**
 * Generic type guard function to check if a proposal type is one of the desired types.
 */
export function isOneOfDesiredPolicyProposalType<T extends ProposalType>(
  type: ProposalType,
  desiredTypes: T[],
): type is T {
  return desiredTypes.includes(type as T)
}
